'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = suggestion;
exports.goUp = goUp;
exports.goDown = goDown;
exports.goTo = goTo;
exports.goToAndSet = goToAndSet;
exports.clearResults = clearResults;
exports.setText = setText;
exports.getResults = getResults;
exports.loadKeywords = loadKeywords;

var _levenshteinEditDistance = require('levenshtein-edit-distance');

var _levenshteinEditDistance2 = _interopRequireDefault(_levenshteinEditDistance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_KEYWORDS = 'redux-frontend/suggestion/LOAD_KEYWORDS'; // import _ from 'lodash';

var LOAD_KEYWORDS_SUCCESS = 'redux-frontend/suggestion/LOAD_KEYWORDS_SUCCESS';
var LOAD_KEYWORDS_FAIL = 'redux-frontend/suggestion/LOAD_KEYWORDS_FAIL';

var GO_UP = 'redux-frontend/suggestion/GO_UP';
var GO_DOWN = 'redux-frontend/suggestion/GO_DOWN';
var GO_TO = 'redux-frontend/suggestion/GO_TO';
var GO_TO_AND_SET = 'redux-frontend/suggestion/GO_TO_AND_SET';

var GET_RESULTS = 'redux-frontend/suggestion/GET_RESULTS';
// const GET_RESULTS_SUCCESS = 'redux-frontend/suggestion/GET_RESULTS_SUCCESS';
// const GET_RESULTS_FAIL = 'redux-frontend/suggestion/GET_RESULTS_FAIL';

var SET_TEXT = 'redux-frontend/suggestion/SET_TEXT';
var CLEAR_RESULTS = 'redux-frontend/suggestion/CLEAR_RESULTS';

var initialState = {
  results: [],
  resultIndex: -1,
  text: '',
  originalText: '',
  keywords: [],
  keywordsLoaded: false
};

function suggestion() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var initIndex = -1;
  switch (action.type) {
    case LOAD_KEYWORDS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        keywords: action.result.searchKeywords,
        keywordsLoaded: true
      });
    case GO_UP:
      if (state.results.length > 0) {
        if (state.resultIndex === -1) {
          initIndex = state.results.length - 1;
        } else {
          initIndex = state.resultIndex - 1;
        }
      }
      return (0, _extends3.default)({}, state, {
        resultIndex: initIndex,
        text: initIndex === -1 ? state.originalText : state.results[initIndex]
      });
    case GO_DOWN:
      if (state.results.length > 0) {
        if (state.resultIndex !== state.results.length - 1) {
          initIndex = state.resultIndex + 1;
        }
      }
      return (0, _extends3.default)({}, state, {
        resultIndex: initIndex,
        text: initIndex === -1 ? state.originalText : state.results[initIndex]
      });
    case GO_TO:
      return (0, _extends3.default)({}, state, {
        resultIndex: action.index
      });
    case GO_TO_AND_SET:
      return (0, _extends3.default)({}, state, {
        text: state.results[action.index],
        originalText: state.results[action.index],
        results: [],
        resultIndex: -1
      });
    case SET_TEXT:
      return (0, _extends3.default)({}, state, {
        text: action.text,
        originalText: action.text,
        resultIndex: -1
      });
    case CLEAR_RESULTS:
      return (0, _extends3.default)({}, state, {
        results: [],
        resultIndex: -1
      });
    case GET_RESULTS:
      return (0, _extends3.default)({}, state, {
        resultIndex: -1,
        text: action.text,
        originalText: action.text,
        results: action.text ? state.keywords.filter(function (res) {
          if (res.toLowerCase().startsWith(state.text.toLowerCase())) {
            return true;
          }
          if (state.text.length >= 3) {
            var minThreshold = Math.ceil(state.text.length * 0.2);
            if ((0, _levenshteinEditDistance2.default)(res.slice(0, state.text.length), state.text, true) <= minThreshold) {
              return true;
            }
          }
          return false;
        }).sort().slice(0, 8) : ['Bangkok', 'Ayutthaya', 'Chiang Mai', 'Floating Market', 'City Tour', 'Street Food']
      });
    // case GET_RESULTS_SUCCESS:
    //   return {
    //     ...state,
    //     keywords: action.result.searchKeywords,
    //     results: action.result.searchKeywords.filter((res) => {
    //       if (res.toLowerCase().startsWith(state.text.toLowerCase())) {
    //         return true;
    //       }
    //       if (state.text.length >= 3) {
    //         const minThreshold = Math.ceil(state.text.length * 0.2);
    //         if (levenshtein(res.slice(0, state.text.length), state.text, true) <= minThreshold) {
    //           return true;
    //         }
    //       }
    //       return false;
    //     }).sort().slice(0, 8)
    //   };
    default:
      return state;
  }
}

function goUp() {
  return {
    type: GO_UP
  };
}

function goDown() {
  return {
    type: GO_DOWN
  };
}

function goTo(index) {
  return {
    type: GO_TO,
    index: index
  };
}

function goToAndSet(index) {
  return {
    type: GO_TO_AND_SET,
    index: index
  };
}

function clearResults() {
  return {
    type: CLEAR_RESULTS
  };
}

function setText() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    type: SET_TEXT,
    text: text
  };
}

function getResults(text) {
  return {
    // types: [GET_RESULTS, GET_RESULTS_SUCCESS, GET_RESULTS_FAIL],
    // promise: (client) => client.get('/configs?keys=searchKeywords'),
    type: GET_RESULTS,
    text: text
  };
}

function loadKeywords() {
  return {
    types: [LOAD_KEYWORDS, LOAD_KEYWORDS_SUCCESS, LOAD_KEYWORDS_FAIL],
    promise: function promise(client) {
      return client.get('/configs?keys=searchKeywords');
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/suggestion.js
// module id = 220
// module chunks = 47